import * as Joi from 'joi';
import { getJoiObject, getNricFinJoiObject } from '../../../utils/JoiUtils';
import { CandidateProfileFormData, CandidateProfileIsDisableInputs } from '../../../models';

const schemaVerifyCandidate = (isDisableInputs?: CandidateProfileIsDisableInputs) =>
  Joi.object<CandidateProfileFormData>({
    name: getJoiObject(
      Joi.string().required().max(66).messages({
        'any.required': 'Name is not allowed to be empty.',
        'string.empty': 'Name is not allowed to be empty.',
        'string.max': 'Name is too long',
      }),
      isDisableInputs?.name
    ),
    IdType: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'ID Type is not allowed to be empty.',
        'string.base': 'ID Type is not allowed to be empty.',
      }),
      isDisableInputs?.IdType
    ),
    NricFin: getNricFinJoiObject(isDisableInputs?.NricFin),
    dateOfBirth: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Date of Birth is not allowed to be empty.',
        'string.empty': 'Date of Birth is not allowed to be empty.',
      }),
      isDisableInputs?.dateOfBirth
    ),
    school: getJoiObject(
      Joi.object().required().messages({
        'any.required': 'School is not allowed to be empty.',
        'object.base': 'School is not allowed to be empty.',
      }),
      isDisableInputs?.school
    ),
  }).options({ stripUnknown: true });

export default schemaVerifyCandidate;
